(function(){
  var RULES = [
    { match:/tote bag/i, emoji:'\u{1F6CD}\u{FE0F}' },
    { match:/flavour discovery sample/i, emoji:'\u{1F4DD}', rename:'KAI Habit Tracker' }
  ];
  function applyTo(p, rule){
    var card=p;
    while(card && card.id!=='kai-gifts-wrap' && (card.style.borderRadius!=='11px')){ card=card.parentNode; }
    if(!card || card.id==='kai-gifts-wrap'){ card=p.parentNode?p.parentNode.parentNode:null; }
    if(card){
      var divs=card.querySelectorAll('div');
      for(var j=0;j<divs.length;j++){
        if((divs[j].getAttribute('style')||'').indexOf('min-height:72px')>=0){
          if(divs[j].textContent!==rule.emoji){ divs[j].textContent=rule.emoji; }
          break;
        }
      }
    }
    if(rule.rename && p.textContent!==rule.rename){ p.textContent=rule.rename; }
  }
  function patch(){
    var wrap=document.getElementById('kai-gifts-wrap');
    if(!wrap){ return; }
    var ps=wrap.querySelectorAll('p');
    for(var i=0;i<ps.length;i++){
      var t=ps[i].textContent;
      for(var k=0;k<RULES.length;k++){
        if(RULES[k].match.test(t)){ applyTo(ps[i], RULES[k]); }
      }
    }
  }
  function start(){
    var w=document.getElementById('kai-gifts-wrap');
    if(w){ patch(); new MutationObserver(patch).observe(w,{childList:true,subtree:true}); }
    else { setTimeout(start,400); }
  }
  if(document.readyState!=='loading'){ start(); }
  else { document.addEventListener('DOMContentLoaded', start); }
})();

(function(){
  var WARN='The product may contain traces of nuts, eggs, lactose, gluten, crustaceans, and molluscs. Do not exceed the recommended daily amount. Food supplements are not a substitute for a balanced and varied diet.<br>Keep out of reach of children!<br>Do not use this food supplement if you are allergic to any of the ingredients or if you have hyperthyroidism (overactive thyroid).<br>If you have any health conditions, are pregnant, or breastfeeding, consult your doctor before use.';
  function buildAcc(){
    var el=document.getElementById('kai-ingredients');
    if(!el){ return; }
    if(el.querySelector('[data-kai-acc]')){ return; }
    var name='', ing='', allerg='';
    var ps=el.querySelectorAll('p');
    if(ps.length){
      ing=ps[0].innerHTML;
      for(var i=1;i<ps.length;i++){ if(/Contains:/i.test(ps[i].textContent)){ allerg=ps[i].innerHTML; } }
    }
    var spans=el.querySelectorAll('span');
    for(var s=0;s<spans.length;s++){ var tx=spans[s].textContent.trim(); if(tx.charAt(0)==='·'){ name=tx.replace(/^·\s*/,''); } }
    var ingDet='';
    if(ing){
      ingDet='<details data-kai-acc style="border:1px solid #E8E2DC;border-radius:12px;overflow:hidden;background:#fff;margin-bottom:10px"><summary style="background:#E3E9EE;padding:11px 14px;display:flex;align-items:center;gap:8px;cursor:pointer"><span style="font-size:13px">\u{1F9EA}</span><span style="font-size:11px;font-weight:800;letter-spacing:0.07em;text-transform:uppercase;color:#080912">Ingredients</span>'+(name?'<span style="font-size:11px;color:#46505A">· '+name+'</span>':'')+'<span class="kai-car" style="margin-left:auto;color:#080912;font-size:11px;transition:.2s">▾</span></summary><div style="padding:11px 14px"><p style="font-size:12px;line-height:1.6;color:#5A544E;margin:0">'+ing+'</p>'+(allerg?'<p style="font-size:11px;color:#6E6862;margin:8px 0 0">'+allerg+'</p>':'')+'</div></details>';
    }
    var warnDet='<details data-kai-acc style="border:1px solid #E8E2DC;border-radius:12px;overflow:hidden;background:#fff"><summary style="background:#E3E9EE;padding:11px 14px;display:flex;align-items:center;gap:8px;cursor:pointer"><span style="font-size:13px">⚠️</span><span style="font-size:11px;font-weight:800;letter-spacing:0.07em;text-transform:uppercase;color:#B4532E">Warnings</span><span class="kai-car" style="margin-left:auto;color:#B4532E;font-size:11px;transition:.2s">▾</span></summary><div style="padding:11px 14px"><p style="font-size:12px;line-height:1.6;color:#5A544E;margin:0">'+WARN+'</p></div></details>';
    el.innerHTML=ingDet+warnDet;
  }
  function startIng(){
    var el=document.getElementById('kai-ingredients');
    if(el){
      var st=document.createElement('style');
      st.textContent='#kai-ingredients summary::-webkit-details-marker{display:none}#kai-ingredients summary{list-style:none}#kai-ingredients details[open] .kai-car{transform:rotate(180deg)}';
      document.head.appendChild(st);
      buildAcc();
      new MutationObserver(buildAcc).observe(el,{childList:true,subtree:true});
    } else { setTimeout(startIng,400); }
  }
  if(document.readyState!=='loading'){ startIng(); }
  else { document.addEventListener('DOMContentLoaded', startIng); }
})();

(function(){
  function wrapTrust(){
    var track=document.querySelector('.kai-trust-track');
    if(!track){ return; }
    if(track.parentNode && track.parentNode.className==='kai-trust-vp'){ return; }
    var vp=document.createElement('div');
    vp.className='kai-trust-vp';
    track.parentNode.insertBefore(vp, track);
    vp.appendChild(track);
  }
  if(document.readyState!=='loading'){ wrapTrust(); }
  else { document.addEventListener('DOMContentLoaded', wrapTrust); }
})();
